import { TextButton } from "@artprov/design-system"
import { exportToExcel } from "../../utils/functions/excelExport"
import { useState } from "react"
import * as Sentry from "@sentry/react"
import PropTypes from "prop-types"

/**
 * Componente para exportar datos a Excel
 * @param {string} textButton - Texto del botón
 * @param {Array} data - Datos a exportar (opcional si se usa onFetchData)
 * @param {Function} onFetchData - Función async para obtener datos bajo demanda
 * @param {string} excelName - Nombre del archivo Excel
 * @param {string} sheetName - Nombre de la hoja (opcional)
 */
export function ExportExcel({ textButton, data, onFetchData, excelName, sheetName }) {
    const [isExporting, setIsExporting] = useState(false)

    const handleExportClick = async () => {
        setIsExporting(true)
        try {
            let dataToExport = data;

            // Si hay función para obtener datos, usarla en lugar de los datos precargados
            if (onFetchData) {
                dataToExport = await onFetchData();
            }

            if (!dataToExport || dataToExport.length === 0) {
                return
            }

            await exportToExcel(dataToExport, excelName, sheetName)
        } catch (error) {
            Sentry.captureException(error)
        } finally {
            setIsExporting(false)
        }
    }

    const isDisabled = isExporting

    return (
        <div
            className={isDisabled ? 'cursor-not-allowed' : ''}
        >
            <TextButton
                onClick={handleExportClick}
                disabled={isDisabled}
                IconLeft="download"
            >
                {isExporting ? textButton : textButton}
            </TextButton>
        </div>
    )
}

ExportExcel.propTypes = {
    textButton: PropTypes.string,
    data: PropTypes.array,
    onFetchData: PropTypes.func,
    excelName: PropTypes.string,
    sheetName: PropTypes.string,
};